export default __webpack_public_path__ + "static/media/390.7838c4ca.jpg";